import { SvgIconNames } from '@toggle/design-system';

export const getEarningsInsightIconName = (
  isPreview: boolean,
  isBordered: boolean
): SvgIconNames => {
  if (isPreview) {
    return isBordered ? 'EarningsPreview' : 'EarningsPreviewBorderless';
  }

  return isBordered ? 'EarningsRecap' : 'EarningsRecapBorderless';
};
